"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nerviano": {
    "39eb88da": [{
      "hkey": "21485f77",
      "slug": "garbatola-villanova",
      "name": "Garbatola-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "garbatola": [{
      "hkey": "21485f77",
      "slug": "garbatola-villanova",
      "name": "Garbatola-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eb60ac10": [{
      "hkey": "21485f77",
      "slug": "garbatola-villanova",
      "name": "Garbatola-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "21485f77",
      "slug": "garbatola-villanova",
      "name": "Garbatola-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nerviano"
    }]
  }
};
exports["default"] = _default;